import { Skeleton } from "./ui/skeleton";

function DashboardSkeleton() {
	return (
		<>
			<div className="rounded-2xl overflow-x-hidden text-center">
				<div className="grid auto-rows-min mb-5 gap-4 md:grid-cols-2">
					<div className="h-50">
						<Skeleton className="h-[100%] rounded-2xl bg-gray-400/10" />
					</div>
					<div className="h-50">
						<Skeleton className="h-[100%] rounded-2xl bg-gray-400/10" />
					</div>
				</div>
				<div className="grid auto-rows-min gap-4 md:grid-cols-4">
					<div className="h-50">
						<Skeleton className="h-[100%] rounded-2xl bg-gray-400/10" />
					</div>
					<div className="h-50">
						<Skeleton className="h-[100%] rounded-2xl bg-gray-400/10" />
					</div>
					<div className="h-50">
						<Skeleton className="h-[100%] rounded-2xl bg-gray-400/10" />
					</div>
					<div className="h-50">
						<Skeleton className="h-[100%] rounded-2xl bg-gray-400/10" />
					</div>
				</div>
				<div className="grid auto-rows-min mt-5 gap-4 md:grid-cols-2">
					<div className="h-50">
						<Skeleton className="h-[100%] rounded-2xl bg-gray-400/10" />
					</div>
					<div className="h-50">
						<Skeleton className="h-[100%] rounded-2xl bg-gray-400/10" />
					</div>
				</div>
			</div>
			<div className="h-150">
				<Skeleton className="h-[100%] rounded-2xl bg-gray-400/10" />
			</div>
		</>
	);
}

export default DashboardSkeleton;
